import { render, staticRenderFns } from "./DiyTabar.vue?vue&type=template&id=50e26f1d&scoped=true&"
import script from "./DiyTabar.vue?vue&type=script&lang=js&"
export * from "./DiyTabar.vue?vue&type=script&lang=js&"
import style0 from "./DiyTabar.vue?vue&type=style&index=0&id=50e26f1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e26f1d",
  null
  
)

export default component.exports